/**
 * Standalone section image (acf.image).
 */

import Image from "next/image";
import { getMediaUrl, OPSI_PART_SPACING } from "../utils/opsiHelpers";

export const OpsiImage = ({ data, className = `opsi-image ${OPSI_PART_SPACING}` }) => {
  const imageUrl = getMediaUrl(data);

  if (!imageUrl) {
    return null;
  }

  const width = data?.width || 1200;
  const height = data?.height || 800;

  return (
    <section className={className} data-opsi-part="image">
      <Image
        src={imageUrl}
        alt={data?.alt || ""}
        width={width}
        height={height}
        className="opsi-image__asset mx-auto !rounded-[15px] mt-[30px] mb-[30px]"
      />
    </section>
  );
};
